var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCheck = function SvgCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#205C40",
    d: "M11.998 3.6a8.4 8.4 0 1 1 0 16.8 8.4 8.4 0 0 1 0-16.8m0 18a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2m4.024-11.576.424-.424-.848-.848-.423.424-4.377 4.377-1.976-1.977-.424-.424-.847.848.424.424 2.4 2.4.423.424.424-.424z"
  })));
};
export default SvgCircleCheck;